import API from '../../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить данные по адресам организации
  async loadGeoItems ({ commit }) {
    var data=null;
    try{
      data = await api.Get("OrganizationService/OrgGeoInfo");
      commit('loadGeoItems', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //добавить
  async addGeoItem({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("OrganizationService/OrgGeoInfo", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("OrganizationService/OrgGeoInfo/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addGeoItem', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //редактировать
  async editGeoItem({commit}, data) {
    var newData = null;
    try {
      await api.Put("OrganizationService/OrgGeoInfo", data);
      var getparams = '?Id=' + data.id;
      newData = await api.Get("OrganizationService/OrgGeoInfo/GetById" + getparams)

      if (newData != null && newData != "")
        commit('editGeoItem', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить
  async deleteGeoItem({commit}, id) {
    try {
      var getparams = '?OrgGeoInfoId=' + id;
      await api.Delete("OrganizationService/OrgGeoInfo", getparams);
      commit('deleteGeoItem',id);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },


}
